<template>
    <!-- <span :class="`uppercase select-none text-xs mr-2 mb-1 inline-block gap-2 px-2 py-0 rounded badge-outline border ${badge}`">{{ text }}</span> -->
    <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset" :class="badge">
        <span class="flex-nowrap whitespace-nowrap inline-flex items-center">
            <Icon v-if="icon" :name="icon" :class="label ? 'mr-1' : ''" />
            {{ label }}
        </span>
    </span>
</template>

<script lang="ts">
export default {
    name: 'Badge',
    props: {
        label: {
            type: String,
            required: false,
        },
        color: {
            type: String,
            required: false,
            default: 'blue',
        },
        icon: String,
    },
    computed: {
        badge() {
            const colours: any = {
                green: 'bg-green-400/10 text-green-400 ring-green-400/20',
                yellow: 'bg-yellow-400/10 text-yellow-500 ring-yellow-400/20',
                blue: 'bg-blue-400/10 text-blue-400 ring-blue-400/30',
                red: 'bg-red-400/10 text-red-400 ring-red-400/20',
                gray: 'bg-gray-400/10 text-gray-400 ring-gray-400/20',
            };

            return colours[this.color];
        },
    },
};
</script>